import type { EntityType } from '@tunasong/schemas'
import {
  EntityTypeList,
  useDimensions,
  useProfileCommands,
  Alert,
  Grid,
  capitalize,
  Link,
  useNavigate,
} from '@tunasong/ui-lib'
import type { FC } from 'react'
import { useState } from 'react'
import { EventCommandsList } from '../commands/event-commands-list.js'
import { InboxAutomations } from './inbox-automations.js'
import styles from './event-config.module.css'

export interface EventConfigProps {}

export const EventConfig: FC<EventConfigProps> = props => {
  const {} = props
  const [selectedType, setSelectedType] = useState<EntityType>()

  const { eventCommands, onChange } = useProfileCommands(selectedType)
  const { isTiny } = useDimensions()
  const listSize = isTiny ? 'small' : 'medium'
  const navigate = useNavigate()

  return (
    <div className={styles.automations}>
      <h2>Automations</h2>
      <p>
        <Link
          href="/app/automations"
          onClick={event => {
            event.preventDefault()
            void navigate('/app/automations')
          }}
        >
          See every automation and what it has done
        </Link>
      </p>

      <InboxAutomations />

      <section aria-label="Focus automations">
        <h3>When you open things</h3>
        <p>Run commands automatically when you open or close a kind of entity.</p>
        <Grid container spacing={2} className={styles.grid}>
          <Grid size={{ xs: 4 }} className={styles.typeList}>
            <EntityTypeList size={listSize} selected={selectedType} onSelect={val => setSelectedType(val)} />
          </Grid>
          <Grid size={{ xs: 8 }} className={styles.commandList}>
            {!selectedType ? <Alert severity="info">Select an entity type to configure event handlers.</Alert> : null}
            {selectedType ? (
              <>
                <Alert severity="info">
                  Event handlers will run for every {capitalize(selectedType)} entity. These handlers will run only for
                  you. Use them to personalize your experience.
                </Alert>

                <EventCommandsList eventCommands={eventCommands} onChange={onChange} />
              </>
            ) : null}
          </Grid>
        </Grid>
      </section>
    </div>
  )
}

export default EventConfig
